module.exports = __webpack_public_path__ + "static/media/ssai_broadpeak.73f633eb.svg";